import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import langMockupData from './mock/langMockupData'
import langData from './mock/LangData.json'

export function getI18nSet(locale) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/menulangs/' + locale,
      method: 'get',
      // 에러 메시지를 출력하는 옵션 - useErrorMessage, false로 정의하면 에러가 나와도 출력되지 않는다. default는 true
      // 권한 점검 옵션 - useAuth, 401 에러일 경우 /login으로 이동하나, 특정 API는 그런 기능을 해제할 필요가 있음. default는 true
      meta: { useErrorMessage: false, useAuth: false }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(langData[locale])
  })
}
